"use client";

import { useEffect, useState, useRef, useContext, useMemo } from "react";
import Cookies from "js-cookie";
import FieldsContext from "../../../context/FieldsContext";
import { useNavigate } from "react-router-dom";
import "./index.css";

const CKDLandingPage = (props) => {
  const { setFields } = useContext(FieldsContext);
  const [current_app] = useState(props.app);
  const [landingPage, setLandingPage] = useState(null);
  const navigate = useNavigate();
  const aboutRef = useRef();
  const validRef = useRef();
  const researchRef = useRef();
  const TakeMetoAppRef = useRef();
  const [termsofuse, setTermsOfUse] = useState(false);
  const [previousIconId, setPreviousIconId] = useState(null);
  const [clickTermsOfUse, setClickTermsOfUse] = useState(false);
  const [hover, setHover] = useState(false);
  const [takeHover, setTakeMeHover] = useState(false);
  const [takeMeButton, setTakeMeButton] = useState(false);
  const [tokenExpiry, setExpiry] = useState(false);
  const token = Cookies.get("sas_token");
  const [privacyPolicy, setPrivacyPolicy] = useState(false);

  const triggerPrivacyBox = () => {
    setPrivacyPolicy(!privacyPolicy);
  };

  useEffect(() => {
    const fetchData = async () => {
      const url = props.LANDING_URL;
      const jwt_token = Cookies.get("jwt_token");
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${jwt_token}`);

      const options = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      try {
        const response = await fetch(url, options);
        const responseObj = await response.json();
        if (responseObj.status === "success") {
          setFields(responseObj.data);
          setLandingPage(responseObj.data.landing_page);
          localStorage.setItem("fields", JSON.stringify(responseObj.data));
        } else {
          alert("Failed to fetch the data");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [setFields, navigate, props.LANDING_URL, props.app, current_app]);

  const logOut = () => {
    Cookies.remove("jwt_token");
    Cookies.remove("sas_token");
    localStorage.clear();
    navigate("/login");
  };

  const getImageBlobUrl = useMemo(() => {
    const imageMap = new Map(props.images.map((img) => [img.id, img.blobUrl]));
    return (id) => imageMap.get(id) || "";
  }, [props.images]);

  function isTokenExpired(url) {
    try {
      const urlParams = new URL(url).searchParams;
      const expiryTime = urlParams.get("se");

      if (expiryTime) {
        const expiryDate = new Date(expiryTime);
        const now = new Date(); // Current time

        return now > expiryDate; // Return true if current time is past expiry
      }

      console.error("The 'se' parameter is missing in the URL.");
      setExpiry(true);
      return true; // Assume expired if 'se' is missing
    } catch (error) {
      console.error("Error parsing URL:", error);
      setExpiry(true);
      return true; // Assume expired in case of errors
    }
  }

  const triggerTermsBox = () => {
    setTermsOfUse(!termsofuse);
  };

  const OnChangeTermsOfUse = () => {
    setClickTermsOfUse(!clickTermsOfUse);
    setTakeMeButton(false);
  };

  const returnToHome = () => {
    navigate("/");
  };

  const handleClickScrollTo = (ref, id) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
    if (previousIconId && previousIconId !== id) {
      const previousIcon = document.getElementById(previousIconId);
      if (previousIcon) {
        previousIcon.style.backgroundColor = ""; // Reset to default
      }
    }
    const iconElement = document.getElementById(id);
    if (iconElement) {
      iconElement.style.backgroundColor =
        props.surface_highlight_color || "#e8e0e8";
    }
    setPreviousIconId(id);
  };

  const takeMeToAction = () => {
    if (clickTermsOfUse) {
      navigate(`/ckd/patient-details`);
    }
    setTakeMeButton(true);
  };

  const renderPoints = (points, level = 0) => {
    if (!points) return null;

    if (Array.isArray(points)) {
      return (
        <ul className={`ckd-landing-nested-points-list level-${level}`}>
          {points.map((point, index) => (
            <li
              key={index}
              className="ckd-landing-nested-point-item"
              style={
                typeof point === "object" && point?.type === "regulatory"
                  ? { listStyle: "none" }
                  : {}
              }
            >
              {renderPoints(point, level + 1)}
            </li>
          ))}
        </ul>
      );
    }

    if (typeof points === "object" && points.type === "regulatory") {
      return (
        <div className="regulatory-box">
          <strong>{points.title}</strong>
          {points.values &&
            points.values.map((val, i) => <p key={i}>{val}</p>)}
        </div>
      );
    }

    if (typeof points === "object" && points.heading) {
      return (
        <div className="ckd-landing-nested-section">
          <strong className="ckd-landing-nested-heading">
            {points.heading}
          </strong>
          {points.points && (
            <div className="ckd-landing-nested-content">
              {renderPoints(points.points, level + 1)}
            </div>
          )}
        </div>
      );
    }

    return <span className="ckd-landing-point-text">{points}</span>;
  };

  const renderSpecialSection = (section) => {
    if (section.details && section.details["Published Abstract Links"]) {
      return (
        <div className="ckd-landing-abstract-section">
          <p className="ckd-landing-abstract-description">
            {section.description}
          </p>
          <div className="ckd-landing-abstract-details">
            {Object.entries(section.details).map(([key, value]) => (
              <div key={key} className="ckd-landing-detail-item">
                <strong>{key}:</strong>
                {Array.isArray(value) ? (
                  <ul className="ckd-landing-link-list">
                    {value.map((link, index) => (
                      <li key={index}>
                        <a
                          href={link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="ckd-landing-abstract-link"
                        >
                          {link}
                        </a>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <span className="ckd-landing-detail-value">{value}</span>
                )}
              </div>
            ))}
          </div>
        </div>
      );
    }
    return null;
  };

  const shouldShowInterpretationImage = (section) => {
    return (
      section.heading &&
      section.heading.toLowerCase().includes("interpretation")
    );
  };

  const shouldShowCertificateImage = (section) => {
    return (
      section.heading && section.heading.toLowerCase().includes("certificate")
    );
  };

  const isAbstractSection = (section) => {
    return section.heading && section.heading.includes("Abstract Acceptance");
  };

  const isWhyCkd = (section) => {
    return (
      section.heading && section.heading.includes("Why is AICKD different?")
    );
  };

  const isMobile = window.innerWidth <= 768;

  return landingPage ? (
    <div className="ckd-landing-app-info-landing-page-container">
      <nav
        className="ckd-landing-heading-bar-container"
        style={{ backgroundColor: props.surface_color || "#f8f9fa" }}
      >
        <div className="ckd-landing-apollo-image-logo-container">
          <img
            src={
              isTokenExpired(
                `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/apollo-logo.png?${
                  token || "/placeholder.svg"
                }`
              ) || tokenExpiry
                ? getImageBlobUrl(`${props.app}-image-1`)
                : `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/apollo-logo.png?${token}`
            }
            alt="apollo-logo"
            className="ckd-landing-apollo-image"
          />
        </div>
        <ul className="ckd-landing-list-of-redirect-elements">
          <div className="ckd-landing-landingpage-action-icons">
            <div
              id="about-icon"
              className="ckd-landing-app-landing-page-icon-container"
              onClick={() => handleClickScrollTo(aboutRef, "about-icon")}
            >
              <img
                src="/group.png"
                alt="about-icon"
                className="ckd-landing-icon-landing"
              />
            </div>
            <li
              className="ckd-landing-nav-link-buttons"
              onClick={() => handleClickScrollTo(aboutRef, "about-icon")}
            >
              About
            </li>
          </div>

          <div className="ckd-landing-landingpage-action-icons">
            <div
              id="validation-icon"
              className="ckd-landing-app-landing-page-icon-container"
              onClick={() => handleClickScrollTo(validRef, "validation-icon")}
            >
              <img
                src="/validation.png"
                alt="validation-icon"
                className="ckd-landing-icon-landing"
              />
            </div>

            <li
              className="ckd-landing-nav-link-buttons"
              onClick={() => handleClickScrollTo(validRef, "validation-icon")}
            >
              Validation
            </li>
          </div>
          <div className="ckd-landing-landingpage-action-icons">
            <div
              id="research-icon"
              className="ckd-landing-app-landing-page-icon-container"
              onClick={() => handleClickScrollTo(researchRef, "research-icon")}
            >
              <img
                src="/research-svgrepo-com.svg"
                alt="research-icon"
                className="ckd-landing-icon-landing"
              />
            </div>

            <li
              className="ckd-landing-nav-link-buttons"
              onClick={() => handleClickScrollTo(researchRef, "research-icon")}
            >
              The Research
            </li>
          </div>
          <div className="ckd-landing-landingpage-action-icons">
            <div
              id="research-icon"
              className="ckd-landing-app-landing-page-icon-container"
            >
              <a
                className="app-landing-page-icon-container"
                href="/FAQ-AICKD-2026.pdf"
                target="_blank"
              >
                <img src="/faq.png" alt="app-icon" className="icon-landing" />
              </a>
            </div>

            <li
              className="ckd-landing-nav-link-buttons"
              onClick={() => handleClickScrollTo(researchRef, "research-icon")}
            >
              FAQ
            </li>
          </div>

          <div className="ckd-landing-landingpage-action-icons">
            <div
              id="app-icon"
              className="ckd-landing-app-landing-page-icon-container"
              onClick={() => handleClickScrollTo(TakeMetoAppRef, "app-icon")}
            >
              <img
                src="/icons8-app.svg"
                alt="app-icon"
                className="ckd-landing-icon-landing"
              />
            </div>

            <li
              className="ckd-landing-nav-link-buttons"
              onClick={() => handleClickScrollTo(TakeMetoAppRef, "app-icon")}
            >
              App
            </li>
          </div>
        </ul>
        <div className="ckd-landing-logout-button-container-block">
          <div className="ckd-landing-landingpage-action-icons">
            <div
              className="ckd-landing-app-landing-page-icon-container"
              onClick={returnToHome}
            >
              <img
                src="/icons8-home.svg"
                alt="home-icon"
                className="ckd-landing-icon-landing"
              />
            </div>

            <button className="ckd-landing-logout-button">Home</button>
          </div>
          <div className="ckd-landing-landingpage-action-icons">
            <div
              className="ckd-landing-app-landing-page-icon-container"
              onClick={logOut}
            >
              <img
                src="/logout-svgrepo-com.svg"
                alt="logout-icon"
                className="ckd-landing-icon-landing"
              />
            </div>

            <button className="ckd-landing-logout-button">Log Out</button>
          </div>
        </div>
      </nav>
      <main className="ckd-landing-main-container">
        <div className="ckd-landing-main-inner-container">
          <div className="ckd-landing-section-block-container ckd-landing-margin-top-10">
            <div
              className="ckd-landing-home-page-content-container"
              style={{ backgroundColor: props.surface_color || "#f8f9fa" }}
            >
              <h1
                className="ckd-landing-heading-apollo-text"
                style={{ color: props.color || "#5fa8d3" }}
              >
                {/* {landingPage[0]?.heading || "AICKD"} */}
                AICKD
              </h1>
              <div
                className="ckd-landing-about-us-container"
                style={{
                  backgroundColor: hover
                    ? props.button_hover_color || "#4a90e2"
                    : props.color || "#5fa8d3",
                }}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => handleClickScrollTo(aboutRef, "about-icon")}
              >
                <button type="button" className="ckd-landing-about-us-button">
                  About us
                </button>
              </div>
            </div>
            <div className="ckd-landing-home-page-image-container">
              <img
                src={
                  isTokenExpired(
                    `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/ckd-landing-image.png?${token}`
                  ) || tokenExpiry
                    ? getImageBlobUrl(`${props.app}-image-2`)
                    : `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/ckd-landing-image.png?${token}`
                }
                className="ckd-landing-copd-home-page-image"
                alt="home-page"
              />
            </div>
          </div>
          <div className="ckd-landing-main-section-inner-block">
            {landingPage.slice(1).map((section, sectionIndex) => (
              <div
                key={sectionIndex}
                className="ckd-landing-each-individual-section ckd-landing-section-border"
                ref={
                  sectionIndex === 0
                    ? aboutRef
                    : sectionIndex === 1
                    ? validRef
                    : sectionIndex === 2
                    ? researchRef
                    : null
                }
              >
                {isAbstractSection(section) && (
                  <div className="ckd-landing-abstract-image-container">
                    <img
                      src={
                        isTokenExpired(
                          `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/abstract-image.jpg?${token}`
                        ) || tokenExpiry
                          ? getImageBlobUrl(`${props.app}-image-7`)
                          : `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/abstract-image.jpg?${token}`
                      }
                      alt="abstract-research"
                      className="ckd-landing-abstract-image"
                    />
                  </div>
                )}

                <h2
                  className={`ckd-landing-each-section-heading ${
                    section.heading &&
                    section.heading.includes("Abstract Acceptance")
                      ? "ckd-landing-abstract-heading"
                      : ""
                  }`}
                >
                  {section.heading}
                </h2>
                <div
                  className={`ckd-landing-section-block-container ${
                    !shouldShowInterpretationImage(section) &&
                    !shouldShowCertificateImage(section) &&
                    !isWhyCkd(section)
                      ? "ckd-landing-no-image"
                      : ""
                  }`}
                >
                  <div className="ckd-landing-landing-content-container">
                    <div
                      className="ckd-landing-landing-list"
                      style={{
                        backgroundColor: props.surface_color || "#f8f9fa",
                      }}
                    >
                      {section.subheading && (
                        <p className="ckd-landing-section-subheading">
                          {section.subheading}
                        </p>
                      )}
                      {section.points && renderPoints(section.points)}
                      {section.content && (
                        <p className="certificate-note-point">
                          {section.content}
                        </p>
                      )}
                      {renderSpecialSection(section)}
                    </div>
                  </div>

                  {isWhyCkd(section) && (
                    <div className="image-container-block mobile-view-image-container">
                      <>
                        <div className="why-image-container image-1-block">
                          <img
                            src={
                              isTokenExpired(
                                `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/ckd-app-page-1.jpg?${token}`
                              ) || tokenExpiry
                                ? getImageBlobUrl(`${props.app}-image-3`)
                                : `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/ckd-app-page-1.jpg?${token}`
                            }
                            alt="Healthcare-1"
                            className="why-image"
                          />
                        </div>
                        <div className="why-image-container image-12block">
                          <img
                            src={
                              isTokenExpired(
                                `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/ckd-app-page-2.jpg?${token}`
                              ) || tokenExpiry
                                ? getImageBlobUrl(`${props.app}-image-4`)
                                : `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/ckd-app-page-2.jpg?${token}`
                            }
                            alt="Healthcare-1"
                            className="why-image"
                          />
                        </div>
                      </>
                    </div>
                  )}

                  {shouldShowInterpretationImage(section) && (
                    <div className="imterpretation-image-container-block">
                      <img
                        src={
                          isTokenExpired(
                            `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/liver-intepretation-img.jpg?${token}`
                          ) || tokenExpiry
                            ? getImageBlobUrl(`${props.app}-image-5`)
                            : `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/liver-intepretation-img.jpg?${token}`
                        }
                        alt="intepretation"
                        className="intepretation-image"
                        style={{
                          height: isMobile
                            ? "400px"
                            : props.app === "prediabetes"
                            ? "740px"
                            : props.app === "liver"
                            ? "440px"
                            : "505px",
                        }}
                      />
                    </div>
                  )}

                  {shouldShowCertificateImage(section) && (
                    <div className="cerficate-image-container-block">
                      <div className="cerficate-intepretation-container">
                        <img
                          src={
                            isTokenExpired(
                              `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/apollo_mdsap_certificate_2026.jpg?${token}`
                            ) || tokenExpiry
                              ? getImageBlobUrl(`${props.app}-image-6`)
                              : `https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/apollo_mdsap_certificate_2026.jpg?${token}`
                          }
                          alt="cerficate"
                          className="cerficate-image"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}

            <div ref={TakeMetoAppRef} className="ckd-landing-container ckd-landing-take-me-to-app">
              <div className="ckd-landing-checkbox-with-text_landing">
                <div className="ckd-landing-checkbox-container">
                  <input
                    type="checkbox"
                    className="ckd-landing-checkbox-input"
                    id="loginCheckBox"
                    onChange={OnChangeTermsOfUse}
                  />
                  <span className="ckd-landing-custom-checkbox">
                    <img
                      src="checkmark-outline-white.svg"
                      alt="checkmark-outline-white"
                    />
                  </span>
                </div>
                <label htmlFor="loginCheckBox" className="ckd-landing-checkbox-text">
                  <span
                    style={{
                      color: takeMeButton ? "red" : "black",
                      fontWeight: takeMeButton ? "600" : "500",
                    }}
                  >
                    I Accept the{" "}
                  </span>
                  <button
                    type="button"
                    className="ckd-landing-new-user-link-tag"
                    href="#"
                    onClick={triggerTermsBox}
                  >
                    Terms of use
                  </button>
                </label>
              </div>
              <button
                id="TakeToMeApp"
                type="button"
                onClick={takeMeToAction}
                style={{
                  backgroundColor: takeHover
                    ? "rgb(123, 104, 171)"
                    : "rgb(103, 84, 150)",
                }}
                onMouseEnter={() => setTakeMeHover(true)}
                onMouseLeave={() => setTakeMeHover(false)}
              >
                Take me to App
              </button>
            </div>

            {termsofuse && (
              <div className="ckd-landing-app-popup-main-container">
                <div className="ckd-landing-app-popup-container">
                  <h1 className="ckd-landing-app-popup-content-heading">
                    Terms of Use
                  </h1>
                  <div className="ckd-landing-app-popup-content-container">
                    <p className="ckd-landing-app-popup-text">
                      By agreeing to use the AICKD Application, I have been made
                      aware of the hardware and software requirements that I
                      will need to set up from my side for a smooth and
                      uninterrupted flow of the Application Programming
                      Interface (API) I undertake to abide by all applicable
                      laws and regulations for the safe and ethical delivery of
                      medical services through this platform and shall adhere by
                      the protocols and standard of care as required. The
                      information that I shared with Apollo Hospitals’ AICKD
                      API, is true to my knowledge and belief and I will be
                      responsible for any legal liability that may arise from
                      in-appropriation of any personal or professional
                      information shared or entered in the API. I accept that I
                      shall be solely responsible for the medical advice and
                      recommendations prescribed post consultation with patients
                      via the AICKD App and any liability that may arise
                      therefrom. I have understood the following disclaimers
                      associated with the use of the AICKD API –
                    </p>
                    <ul className="ckd-landing-app-popup-list-container">
                      <li>
                        This is not a diagnostic tool and it does not guarantee
                        the accuracy of the result and cannot be independently
                        acted upon.
                      </li>
                      <li>
                        To ensure the information in the report is up to date,
                        accurate and correct, Doctor shall be consulted for
                        interpretation of the report. He / She shall also ensure
                        that the entries made in the API are correct.
                      </li>
                      <li>
                        Apollo Hospitals and its Staff does not offer any
                        assurance on the information made available or shall be
                        liable for any loss or damage as the said report is
                        based on the AICKD Disease Progression without any
                        intervention from their side.
                      </li>
                      <li>
                        By usage of AICKD Disease Progression, it is deemed that
                        the beneficiary of this service has agreed to get the
                        same done at his/her own risk and further agrees with
                        this disclaimer without any limitation or any clauses or
                        sub-clauses.
                      </li>
                    </ul>
                    <p className="app-popup-text">
                      Confidentiality: Each Party hereby undertakes that it will
                      not disclose the Confidential Information of the other
                      party, except to its affiliates, employees, and/or agents
                      who need to know such Confidential Information for the
                      purpose of performance of obligations hereunder, provided
                      they have agreed in writing to keep such information
                      confidential and to not use such information for any
                      unauthorized purposes. The recipient of Confidential
                      Information may disclose Confidential Information as
                      required under Applicable Laws, after giving to the
                      discloser of such Confidential Information, reasonable
                      notice and the opportunity to seek confidential treatment
                      by way of a protective order or similar remedies or relief
                      prior to disclosure, in each case if permitted by
                      applicable Law. Except as set forth in this Agreement,
                      neither Party will issue any public announcement.
                    </p>
                  </div>
                  <div className="ckd-landing-app-popup-close-container">
                    <button
                      className="ckd-landing-app-popup-close-button"
                      type="button"
                      onClick={triggerTermsBox}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
            {privacyPolicy && (
              <div id="aicvd-termsBox" className="app-popup-main-container">
                <div className="app-popup-container">
                  <h1 className="app-popup-content-heading">Privacy Policy</h1>
                  <div className="app-popup-content-container">
                    <p className="app-popup-text">
                      For users, including those under Vendors, Importers, and
                      all entities using the Clinical API.{" "}
                    </p>
                    <p className="app-popup-text">DO NOT -</p>

                    <ul className="app-popup-list-container">
                      <li>
                        Access or use the Clinical AI APIs, Documentation, or
                        associated cloud services except as expressly permitted
                        by the Clinical AI subscription and distribution
                        agreement.
                      </li>
                      <li>
                        Decompile, disassemble, or reverse engineer or attempt
                        to discover any source code or algorithms included in,
                        or accessed by, the Clinical AI APIs or associated cloud
                        services.
                      </li>
                      <li>
                        Hamper with or misuse the technical delivery systems
                        used in connection with the Clinical AI Tool or
                        associated cloud services.{" "}
                      </li>
                      <li>
                        Other than as expressly permitted by Agreement, copy,
                        edit, reproduce, modify, distribute, transmit, sell,
                        resell, display, perform, make translations, or other
                        derivative works of the Clinical AI Tools,
                        Documentation, associated cloud services, or any data or
                        other information made available hereunder or via the
                        Clinical AI APIs & Services
                      </li>
                      <li>
                        Introduce any Viruses into the Clinical AI APIs or
                        Associated cloud services
                      </li>
                      <li>
                        Interfere with, or attempt to interfere with, the
                        Clinical AI APIs or the associated cloud services or the
                        lawful access to or use of the Clinical AI APIs or
                        associated cloud services by any other Person
                      </li>
                      <li>
                        Alter, remove, obscure, or change the location, content,
                        or appearance of any disclaimers, notices of copyright,
                        trademark, service mark, or other proprietary rights, or
                        other notices included in the Clinical AI tools,
                        Documentation, or Associated cloud services
                      </li>
                      <li>
                        Violate any applicable Law in connection with this
                        Agreement or use the Clinical AI APIs and Technology
                        (including any data or other information obtained in
                        connection therewith), or associated cloud services in a
                        way that violates applicable Law or infringes the
                        intellectual property rights of any third party.
                      </li>
                    </ul>
                  </div>
                  <div className="app-popup-close-container">
                    <button
                      className="app-popup-close-button"
                      type="button"
                      onClick={triggerPrivacyBox}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <footer
          id="footer"
          className="container footer-block"
          style={{ backgroundColor: props.surface_color }}
        >
          <p className="footer-inside-element">
            ©{new Date().getFullYear()} Apollo Hospitals Enterprise Ltd, All
            Rights Reserved
          </p>
          <div className="footer-button-container">
            <button className="landing-footer-button" type="button">
              <a
                className="footer-link-tag"
                href="mailto:clinicalailabs@apollohospitals.com"
              >
                Feedback
              </a>
            </button>
            <button
              className="landing-footer-button"
              type="button"
              onClick={triggerPrivacyBox}
            >
              Privacy Policy
            </button>
          </div>
        </footer>
      </main>
    </div>
  ) : (
    <div className="ckd-landing-app-loading-container">
      <div className="ckd-landing-login-loader-container">
        <div className="ckd-landing-loading-spinner">Loading...</div>
      </div>
    </div>
  );
};

export default CKDLandingPage;
